import React, { useEffect, useState } from 'react';
import { connect, useStore } from 'react-redux';
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import { default as commonUtil } from '../../../common/commonUtil';
import { getAvailablePlan, getFacilityInfo } from "../../../const";
import Const from '../../../const/Const';
import messageConst from '../../../const/messageConst';
import common from '../../../resources/js/common/common';
import { Button } from '../../atoms/button';
import { Label } from '../../atoms/label';
import { OptionPullDown } from '../../atoms/optionPullDown';
import { ErrorMassage } from '../../molecules/errorMassage';
import { ModalOptionForm } from '../../molecules/modalOptionForm';
import { PullDownOptionForm } from '../../molecules/pullDownOptionForm';
import './../../../resources_membership_hotel/css/hotel/reserve.css';

const SideSearchFormContainer = (props) => {
    const { data,
        state,
        login,
        checkIn,
        checkOut,
        room,
        adultNum,
        childNum,
        setRoom,
        setAdultNum,
        setChildNum,
        resvKaiinken,
        setResvKaiinken,
        planConditions,
        grade,
        food,
        privilegedService,
        membershipFacility,
        membershipSearchParam,
        setMembershipSearchParam,
        setPlanConditions,
        setGrade,
        setFood,
        setPrivilegedService,
        setMembershipFacility,
        setLoadingFlg,
        setOpenFacilityFlg,

        onClickOpenReservationPopupWindow,
        onClickOpenCheckListWindow,
        onClickOpenCalendarWindow,
        handlePlanList,
        handleSaveSearchCondition,
        setMembershipResvStartDate,
        setDispFacility,
        setSelectKeiyakuNo,
        setDispDetailCondition } = props;

    const isMobilePhone = useMedia({ maxWidth: '480px' });
    const [mobilePhone, setMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();

    const [roomNumber, setRoomNumber] = useState("1");
    const [dispAdultNum, setDispAdultNum] = useState("2");
    const [dispChildNum, setDispChildNum] = useState("0");
    const [kaiinkenNumber, setKaiinkenNumber] = useState("1");
    const [gradeNumber, setGradeNumber] = useState("1");

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [errFlgList, setErrFlgList] = useState({ errFacility: false, errPeopleNum: false, errAdultNum: false });

    useEffect(() => {
        if (isMobilePhone) {
            setMobilePhone(true);
        } else {
            setMobilePhone(false);
        }
    }, [isMobilePhone]);

    useEffect(() => {
        displaySearchConditions();
    }, []);

    useEffect(() => {
        if (state.popupMode == "savedSearch" && !state.reservationPopup) {
            displaySearchConditions();
        }
    }, [state.reservationPopup]);

    // 検索条件初期表示
    const displaySearchConditions = () => {
        resvKaiinken.forEach((data) => {
            if (data.selected === true) {
                setKaiinkenNumber(data.id);
                membershipFacility.membership.forEach(group => {
                    const selectedFacility = group.shisetsuList.find(facility => facility.id == data.sisetuCd);
                    if (selectedFacility) {
                        setOpenFacilityFlg(selectedFacility.openFlg);
                    }
                })
            }
        });
        room.forEach((data) => {
            if (data.selected === true) setRoomNumber(data.id);
        });
        adultNum.forEach((data) => {
            if (data.selected === true) setDispAdultNum(data.id);
        });
        childNum.forEach((data) => {
            if (data.selected === true) setDispChildNum(data.id);
        });
    }

    // 検索ボタン押下時
    const onClickSearch = () => {
        setLoadingFlg(true);
        // バリデーションフラグ
        let errFlg = false;
        let errorMessage = [];
        let flgList = { errFacility: false, errPeopleNum: false, errAdultNum: false };

        // チェックイン
        const startDate = commonUtil.getStringFromDate(new Date(checkIn), "yyyy-MM-dd");
        // チェックアウト
        const endDate = commonUtil.getStringFromDate(new Date(checkOut), "yyyy-MM-dd");
        // 室数
        let vacancyNum = 1;
        room.forEach((data) => {
            if (data.selected === true) vacancyNum = parseInt(data.id);
        });

        // 会員権
        let keiyakuNo = "";
        let kaiinkenCd = "";
        let kaiinkenNo = "";
        let riyoKaiinkenSyubetCd = "";
        let targetShisetsuCd = "";

        resvKaiinken.forEach((data) => {
            if (data.selected === true) {
                keiyakuNo = data.keiyakuNo;
                kaiinkenCd = data.id;
                kaiinkenNo = data.value;
                riyoKaiinkenSyubetCd = data.riyoKaiinkenSyubetCd;
                targetShisetsuCd = data.sisetuCd;
            }
        });

        // 施設
        let facilityArray = [];
        let openingDate = "";
        membershipFacility.membership.forEach((data) => {
            if (data.shisetsuList) {
                data.shisetsuList.forEach(item => {
                    if (item.checked) facilityArray.push(item.id);
                    if (item.id == targetShisetsuCd && item.openingDate) {
                        openingDate = item.openingDate;
                    }
                })
            }
        });
        membershipFacility.ippan.forEach((data) => {
            if (data.shisetsuList) {
                data.shisetsuList.forEach(item => {
                    if (item.checked) facilityArray.push(item.id);
                })
            }
        });
        if (facilityArray.length === 0) {
            membershipFacility.membership.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (!item.disabled) facilityArray.push(item.id);
                    })
                }
            });
            membershipFacility.ippan.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (!item.disabled) facilityArray.push(item.id);
                    })
                }
            });
        }
        if (openingDate != "" && commonUtil.checkOpeningDate(startDate, endDate, openingDate)) {
            errorMessage.push(messageConst.OPENING_DATE_ERROR);
            errFlg = true;
        }

        // 1室あたりの人数
        let adults = 2;
        adultNum.forEach((data) => {
            if (data.selected === true) adults = parseInt(data.id);
        });
        let children = 1;
        childNum.forEach((data) => {
            if (data.selected === true) children = parseInt(data.id);
        });
        if (adults + children > Const.MAX_ROOM_CAPACITY) {
            errorMessage.push(messageConst.PEOPLE_NUM_ERROR);
            errFlg = true;
            flgList.errPeopleNum = true;
        }
        // if (adults < vacancyNum) {
        //     errorMessage.push(messageConst.ADULT_NUM_ERROR);
        //     errFlg = true;
        //     flgList.errAdultNum = true;
        // }

        //// グレード
        // let gradeArray = [];
        // grade.forEach((data) => {
        //     if (data.checked === true) gradeArray.push(data.id);
        // });

        // プラン条件
        let planConditionsArray = [];
        planConditions.forEach((data) => {
            if (data.checked === true) planConditionsArray.push(data.id);
        });

        // 夕食
        let foodArray = [];
        food.forEach((data) => {
            if (data.checked === true) foodArray.push(data.id);
        });

        // サービス権利
        let privilegedServiceArray = [];
        privilegedService.forEach((data) => {
            if (data.checked === true) privilegedServiceArray.push(data.id);
        });

        // リクエスト情報設定
        const req = {
            checkInDate: startDate,
            checkOutDate: endDate,
            shisetsuCdList: facilityArray,
            adultCnt: adults,
            childCnt: children,
            roomCnt: vacancyNum,
            keiyakuNo: keiyakuNo,
            planConditionsCdList: planConditionsArray,
            roomGradeCdList: [],
            foodCdList: foodArray,
            privilegedServiceCdList: privilegedServiceArray,
            riyoKaiinkenSyubetCd: riyoKaiinkenSyubetCd
        };
        setErrFlgList(flgList);
        if (errFlg) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: errorMessage, errorFlg: true, });
            handlePlanList([]);
        } else {
            setMembershipSearchParam({
                checkInDate: startDate,
                checkOutDate: endDate,
                nights: commonUtil.getNights(startDate, endDate, "-"),
                shisetsuCdList: facilityArray,
                adultCnt: adults,
                childCnt: children,
                roomCnt: vacancyNum,
                keiyakuNo: keiyakuNo,
                planConditionsCdList: planConditionsArray,
                roomGradeCdList: [],
                foodCdList: foodArray,
                privilegedServiceCdList: privilegedServiceArray,
                kaiinkenCd: kaiinkenCd,
                kaiinkenNo: kaiinkenNo,
                riyoKaiinkenSyubetCd: riyoKaiinkenSyubetCd,
            });
            setErrorInfo({ errorMessage: null, errorFlg: false, });
            // プラン検索処理
            common.doPost(getAvailablePlan, req, afterGetAvailablePlan);
            history.push("/reserve/hotel/searchResult");
        }
    }
    const afterGetAvailablePlan = (res) => {
        const data = res.data;
        // エラーが発生した場合はメッセージを表示
        if (data.resultCode != "0") {
            setErrorInfo({ errorMessage: [messageConst.SEARCH_ERROR], errorFlg: true, });
            handlePlanList([]);
            return;
        }        
        if (data.resultCode == "0" && (!data.shisetsuList || !data.shisetsuList.length)) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: [messageConst.HOTEL_PLAN_NOT_FOUND_ERROR], errorFlg: true, });
            handlePlanList([]);
            return;
        }
        // 検索時間設定
        setMembershipResvStartDate(commonUtil.getStringFromDate(new Date(), "yyyy-MM-dd"));
        handlePlanList(data.shisetsuList);
    }

    // チェックイン日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkInDate = new Date(checkIn);
        const y = checkInDate.getFullYear();
        const m = checkInDate.getMonth() + 1;
        const d = checkInDate.getDate();

        return `${y}年${m}月${d}日(${youbi[checkInDate.getDay()]})`;
    }
    // チェックアウト日表示処理
    const getDateToString2 = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkOutDate = new Date(checkOut);
        const y = checkOutDate.getFullYear();
        const m = checkOutDate.getMonth() + 1;
        const d = checkOutDate.getDate();

        return `${y}年${m}月${d}日(${youbi[checkOutDate.getDay()]})`;
    }

    // 施設表示
    const getFacility = () => {
        let dispText = store.getState().dispFacility ? store.getState().dispFacility : "選択なし";
        return dispText;
    }

    // 詳細条件表示
    const getDetailCriteria = () => {
        let dispText = store.getState().dispDetailCondition ? store.getState().dispDetailCondition : "選択なし";
        return dispText;
    }

    const onChangeKaiinkenName = (e) => {
        let keiyakuNo = "";
        let selectShisetsuCd = "";
        setKaiinkenNumber(e.target.value);
        resvKaiinken.forEach((data) => {
            if (String(data.id) === e.target.value) {
                data.selected = true;
                keiyakuNo = data.keiyakuNo;
                selectShisetsuCd = data.sisetuCd;
            } else {
                data.selected = false;
            }
        })
        membershipFacility.membership.forEach(group => {
            const selectedFacility = group.shisetsuList.find(facility => facility.id == selectShisetsuCd);
            if (selectedFacility) {
                setOpenFacilityFlg(selectedFacility.openFlg);
            }
        });
        setSelectKeiyakuNo(keiyakuNo);
        setResvKaiinken(resvKaiinken);
        setDispFacility("選択なし");
        setDispDetailCondition("選択なし");
        // 施設・部屋グレード情報取得
        common.doPost(getFacilityInfo, { keiyakuNo: keiyakuNo }, afterGetFacilityInfo);
    }
    // 施設・部屋グレード情報取得後処理
    const afterGetFacilityInfo = (res) => {
        const data = res.data;
        if (data.resultCode == 0) {
            let memberHotelList = [];
            data.shisetsuInfo?.memberHotelList && data.shisetsuInfo.memberHotelList.forEach(main => {
                let list = [];
                main.shisetsuList.forEach(membership => {
                    let membershipObj = { class: "facility", id: membership.shisetsuCd, value: membership.shisetsuName, checked: false, disabled: !membership.enable, openFlg: membership.openFlg, openingDate: membership.openingDate }
                    list.push(membershipObj);
                })
                let mainBuildingObj =
                {
                    mainGroupCd: main.mainGroupCd,
                    mainGroupName: main.mainGroupName,
                    checked: false,
                    displayFlg: false,
                    disabled: main.honkanShisetsuRiyoFlg,
                    shisetsuList: list
                };
                memberHotelList.push(mainBuildingObj);
            })

            let generalHotelList = [];
            data.shisetsuInfo?.generalHotelList && data.shisetsuInfo.generalHotelList.forEach(main => {
                let list = [];
                main.shisetsuList.forEach(ippan => {
                    let ippanObj = { class: "facility", id: ippan.shisetsuCd, value: ippan.shisetsuName, checked: false, disabled: !ippan.enable }
                    list.push(ippanObj);
                })
                let mainBuildingObj =
                {
                    mainGroupCd: main.mainGroupCd,
                    mainGroupName: main.mainGroupName,
                    checked: false,
                    displayFlg: false,
                    disabled: false,
                    shisetsuList: list
                };
                generalHotelList.push(mainBuildingObj);
            })
            setMembershipFacility({ membership: memberHotelList, ippan: generalHotelList });

            let grades = [];
            data.roomGradeList.forEach(value => {
                let item = { class: "gradeList", id: value.gradeCd, value: value.gradeName, checked: false, disabled: !value.enable }
                grades.push(item);
            })
            setGrade(grades);

            let planConditionsList = [];
            data.planConditionsList.forEach(value => {
                let item = { class: "planConditions", id: value.planConditionsCd, value: value.planConditionsName, checked: false, disabled: !value.enable }
                planConditionsList.push(item);
            })
            setPlanConditions(planConditionsList);

            let foodList = [];
            data.foodList.forEach(value => {
                let item = { class: "foodList", id: value.foodCd, value: value.foodName, checked: false, disabled: !value.enable }
                foodList.push(item);
            })
            setFood(foodList);

            let privilegedServiceList = [];
            data.privilegedServiceList.forEach(value => {
                let item = { class: "privilegedService", id: value.privilegedServiceCd, value: value.privilegedServiceName, checked: false, disabled: false, description: value.privilegedServiceText }
                privilegedServiceList.push(item);
            })
            setPrivilegedService(privilegedServiceList);
        }
    }

    // 選択した組数をstoreに保存
    const onChangeRoom = (e) => {
        setRoomNumber(e.target.value);

        room.forEach((data) => {
            if (data.id === e.target.value) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setRoom(room);
    };
    // 選択した組数をstoreに保存
    const onChangeAdultNum = (e) => {
        setDispAdultNum(e.target.value);
        const selected = e.target.value;
        adultNum.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setAdultNum(adultNum);
    };
    // 選択した組数をstoreに保存
    const onChangeChildNum = (e) => {
        setDispChildNum(e.target.value);
        const selected = e.target.value;
        childNum.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setChildNum(childNum);
    };

    return (
        <div className="container">
            <div className="searchConditions">
                <div style={errorInfo.errorFlg ? style.errorDiv : { display: "none" }}>
                    <ErrorMassage style={style.errorMassage} data={errorInfo.errorMessage} />
                </div>
                <div className="membershipSideSearchWrap">
                    <ModalOptionForm
                        id={"checkIn"}
                        divClass={isMobilePhone ? "wrapMobile" : "membershipSideSearchItemWrap"}
                        title={"チェックイン"}
                        onClick={onClickOpenCalendarWindow}
                        text={getDateToString()} />
                    <ModalOptionForm
                        id={"checkOut"}
                        divClass={isMobilePhone ? "wrapMobile" : "membershipSideSearchItemWrap"}
                        title={"チェックアウト"}
                        onClick={onClickOpenCalendarWindow}
                        text={getDateToString2()} />
                    <ModalOptionForm
                        id={"facility"}
                        divClass={isMobilePhone ? "wrapMobile" : "membershipSideSearchItemWrap"}
                        title={"ホテル"}
                        onClick={onClickOpenCheckListWindow}
                        text={getFacility()}
                        dateClass={errFlgList.errFacility ? "popupButtonErr" : ""}
                    />
                    <div className={isMobilePhone ? "wrapMobile" : "membershipSideSearchItemWrap"}>
                        <Label className={"membershipModalLabel"} label={"1室あたり利用人数\n（小学生未満の人数は入力不要）"} />
                        <div className={isMobilePhone ? "" : "humanInputBlock"}>
                            <div className={isMobilePhone ? "humanPullDownSp" : "humanPullDownResult"}>
                                <Label className={"modalLabel"} label="大人" />
                                <OptionPullDown
                                    data={adultNum}
                                    selectClass={errFlgList.errPeopleNum || errFlgList.errAdultNum ? "humanPullDownOptionStyleErr" : "humanPullDownOptionStyle"}
                                    onChange={onChangeAdultNum}
                                    value={dispAdultNum}
                                    id="adultNum" />
                            </div>
                            <div className={isMobilePhone ? "humanPullDownSp" : "humanPullDownResult"}>
                                <Label className={"modalLabel"} label="小学生" />
                                <OptionPullDown
                                    data={childNum}
                                    selectClass={errFlgList.errPeopleNum ? "humanPullDownOptionStyleErr" : "humanPullDownOptionStyle"}
                                    onChange={onChangeChildNum}
                                    value={dispChildNum}
                                    id="childNum" />
                            </div>
                        </div>
                    </div>
                    <PullDownOptionForm
                        id="roomNum"
                        divClass={isMobilePhone ? "wrapMobile" : "membershipSideSearchItemWrap"}
                        title={"室数"}
                        selectClass={"pullDownOptionStyle"}
                        data={room}
                        state={roomNumber}
                        onChange={onChangeRoom}
                        labelClassName="modalLabel"
                    />
                    <PullDownOptionForm
                        id="kaiinken"
                        divClass={isMobilePhone ? "wrapMobile" : "membershipSideSearchItemWrap"}
                        title={"会員権選択"}
                        selectClass="pullDownOptionKaiinkenStyle"
                        labelClassName="modalLabel"
                        data={resvKaiinken}
                        state={kaiinkenNumber}
                        onChange={onChangeKaiinkenName}
                    />
                    <ModalOptionForm
                        id={"detailCriteria"}
                        divClass={isMobilePhone ? "wrapMobile" : "membershipSideSearchItemWrap"}
                        title={"詳細条件"}
                        onClick={onClickOpenCheckListWindow}
                        text={getDetailCriteria()}
                    />
                    <div className="onlyPlanWrap">
                    </div>
                </div>

                <div className="searchbox">
                    <Button buttonText="検 索" className="btnReservationSide" onClick={onClickSearch} buttonClassName="serachBtnText" tabIndex="12" />
                </div>
                <div style={{ marginTop: "25px" }}>
                    <Button
                        className="saveSearchConditionBtn"
                        onClick={handleSaveSearchCondition}
                        buttonText="この検索条件を保存"
                        buttonClassName="conditionBtnText"
                        tabIndex="13"
                    />
                    <Button
                        className="searchConditionBtn"
                        onClick={() => onClickOpenReservationPopupWindow("savedSearch", login.memberCode)}
                        buttonText="保存した検索条件"
                        buttonClassName="conditionBtnText"
                        tabIndex="14"
                    />
                </div>
            </div>
        </div>
    );
}

const style = {
    errorMassage: {
        display: "inline-block",
        whiteSpace: "pre-line",
        textAlign: "center",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        keyWord: state.keyWord,
        facility: state.facility,
        detailCondition: state.detailCondition,
        room: state.room,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        resvKaiinken: state.resvKaiinken,
        adultNum: state.adultNum,
        childNum: state.childNum,
        planConditions: state.planConditions,
        grade: state.grade,
        food: state.food,
        privilegedService: state.privilegedService,
        membershipFacility: state.membershipFacility,
        membershipSearchParam: state.membershipSearchParam,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setResvKaiinken: (item) => {
            dispatch({ type: "RESV_KAIINKEN", payload: { resvKaiinken: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
        setGrade: (item) => {
            dispatch({ type: "GRADE", payload: { grade: item } })
        },
        setPlanConditions: (item) => {
            dispatch({ type: "PLAN_CONDITIONS", payload: { planConditions: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: "PRIVILEGED_SERVICE", payload: { privilegedService: item } })
        },
        setFood: (item) => {
            dispatch({ type: "FOOD", payload: { food: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setMembershipResvStartDate: (item) => {
            dispatch({ type: "MEMBERSHIP_RESV_START_DATE", payload: { membershipResvStartDate: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setDispDetailCondition: (item) => {
            dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: item } })
        },
    };
}



export default connect(mapStateToProps, mapDispatchToProps)(SideSearchFormContainer);